export const extractTokenUsage = (payload) => {
  if (!payload || typeof payload !== "object") return null;

  const raw =
    payload.token_usage ||
    payload.result?.token_usage ||
    payload.fastapi_response?.token_usage ||
    payload.body?.token_usage ||
    null;

  if (!raw || typeof raw !== "object") return null;

  return {
    query_count: Number(raw.query_count ?? raw.queryCount ?? 0) || 0,
    prompt_tokens: Number(raw.prompt_tokens ?? raw.promptTokens ?? 0) || 0,
    session_output_tokens:
      Number(raw.session_output_tokens ?? raw.sessionOutputTokens ?? 0) || 0,
    total_tokens: Number(raw.total_tokens ?? raw.totalTokens ?? 0) || 0,
    limit: Number(raw.limit ?? 0) || 0,
    blocked: raw.blocked === true || String(raw.blocked || "").toLowerCase() === "true",
  };
};

export const isSessionLimitReached = (tokenUsage) => {
  if (!tokenUsage || typeof tokenUsage !== "object") return false;

  const total = Number(tokenUsage.total_tokens ?? 0);
  const limit = Number(tokenUsage.limit ?? 0);
  return tokenUsage.blocked === true || (limit > 0 && total >= limit);
};

export const tokenUsageMatches = (tokenUsageA, tokenUsageB) => {
  if (!tokenUsageA || !tokenUsageB) return false;
  return (
    Number(tokenUsageA.total_tokens || 0) === Number(tokenUsageB.total_tokens || 0) &&
    Number(tokenUsageA.limit || 0) === Number(tokenUsageB.limit || 0) &&
    Boolean(tokenUsageA.blocked) === Boolean(tokenUsageB.blocked)
  );
};

export const isSessionLimitError = (payload) => {
  return (
    payload &&
    typeof payload === "object" &&
    String(payload.error || "").toUpperCase() === "SESSION_LIMIT_REACHED"
  );
};

export const getSessionLimitMessage = (payload) => {
  if (!payload || typeof payload !== "object") {
    return "Session limit reached. Please start a new session.";
  }
  return (
    payload.message ||
    payload?.result?.message ||
    "Session limit reached. Please start a new session."
  );
};
